import Animated, {
  interpolate,
  useAnimatedStyle,
} from "react-native-reanimated";
import React, { PropsWithChildren, useMemo } from "react";
import { TapGestureHandler } from "react-native-gesture-handler";

import { useRadiusSize } from "arkh";
import { useWidgetLayout } from "../WidgetLayoutContext";
import { Platform } from "react-native";

export const PageWrapper = ({
  children,
  index,
  y,
  length,
  waitFor,
  onPress,
}: PropsWithChildren<{
  index: number;
  y: Animated.SharedValue<number>;
  length: number;
  waitFor: React.Ref<unknown> | undefined;
  onPress: () => void;
}>) => {
  const { width, height } = useWidgetLayout();

  const inputRange = useMemo(
    () =>
      Array(length + 1)
        .fill(0)
        .map((_, index) => index * height),
    [height, length]
  );
  const outputRange = useMemo(
    () =>
      Array(length + 1)
        .fill(0.6)
        .map((_, i) => (i === index ? 1 : 0.8)),
    [index, length]
  );
  const animatedStyles =
    Platform.OS === "web"
      ? {}
      : // eslint-disable-next-line react-hooks/rules-of-hooks
        useAnimatedStyle(() => {
          return {
            transform: [
              {
                scale: interpolate(y.value, inputRange, outputRange),
              },
            ],
          };
        });
  const borderRadius = useRadiusSize("medium");
  return (
    <TapGestureHandler
      waitFor={waitFor}
      onActivated={() => {
        onPress();
      }}
    >
      <Animated.View
        style={[
          {
            width,
            height,
            borderRadius,
            overflow: "hidden",
          },
          animatedStyles,
        ]}
      >
        {children}
      </Animated.View>
    </TapGestureHandler>
  );
};
